import { ActionType } from "@sp-crm/core";
import React from "react";
import { Redirect, Route, Switch } from "react-router";
import {
    useFranchiseManagementEnabled,
    useIsAllowedInWholeTenant,
} from "store/selectors/hooks";
import { FranchiseSettingsDefaults } from "./franchise-settings-defaults";
import { FranchiseSettingsNav } from "./franchise-settings-nav";
import { FranchiseSettingsTerritories } from "./franchise-settings-territories";

export const FranchiseSettings: React.FC<unknown> = () => {
    const isEnabled = useFranchiseManagementEnabled();
    const canUpdate = useIsAllowedInWholeTenant(ActionType.UpdateFranchiseTerritory);

    if (!isEnabled || !canUpdate) {
        return null;
    }

    return (
        <div className="lg:flex lg:gap-x-5">
            <div className="lg:w-56 lg:shrink-0">
                <FranchiseSettingsNav />
            </div>
            <div className="lg:flex-1 lg:min-w-0 pb-4">
                <Switch>
                    <Route
                        path="/settings/franchise/territories"
                        component={FranchiseSettingsTerritories}
                    />
                    <Route
                        path="/settings/franchise/defaults"
                        component={FranchiseSettingsDefaults}
                    />
                    <Route
                        path="/settings/franchise"
                        render={() => <Redirect to="/settings/franchise/territories" />}
                    />
                </Switch>
            </div>
        </div>
    );
};
